import { createContext, useContext } from 'react'

/**
 * Callback type for syncing the autoLocked ref in Component.js
 * when manual lock/unlock operations occur in LockAction.
 *
 * @param locked - true after a successful manual lock (claimRegistration),
 *                 false after a successful manual unlock (cedeRegistration)
 */
type LockSyncCallback = (locked: boolean) => void

const noop: LockSyncCallback = () => {}

const LockSyncContext = createContext<LockSyncCallback>(noop)

export const LockSyncProvider = LockSyncContext.Provider

export const useLockSync = () => useContext(LockSyncContext)
